import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconPlayroom = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconPlayroom",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M12.4 3.18 12 3l-.4.18-9 4A1 1 0 1 0 3.4 9L12 5.2 20.6 9a1 1 0 0 0 .8-1.82zM20 21H4v-1h16zm-2.02-4.66-.68-4.38c-.17-1.13-1.23-1.96-2.47-1.96H9.17c-1.24 0-2.3.83-2.47 1.96l-.68 4.38c-.14.88.6 1.66 1.57 1.66q.66 0 1.12-.43l1.42-1.28h3.74l1.4 1.28c.3.28.71.43 1.13.43.98 0 1.72-.78 1.58-1.66m-6.6-2.91h-1.25v1.14H9.5v-1.14H8.25v-.57H9.5V11.7h.63v1.15h1.25zm2.5-.57c-.35 0-.63-.26-.63-.57 0-.32.28-.58.62-.58.35 0 .63.26.63.58s-.28.57-.63.57m1.24 1.71c-.34 0-.62-.26-.62-.57s.28-.57.62-.57c.35 0 .63.26.63.57s-.28.57-.63.57"
  })
}));
IconPlayroom.displayName = 'IconPlayroom';